export default "__VITE_ASSET__DBVmCIzC__"